import { get, post } from '../index'
export default{
  // 获取房产分类列表
  getHouseClassifyList (querys) {
    return get('/house/admin/AdminCate/cateList', querys)
  },
  // 添加房产分类
  addHouseClassify (querys) {
    return post('/house/admin/AdminCate/cateAdd', querys)
  },
  // 房产分类编辑、回显
  getEditHouseClassify (querys) {
    return post('/house/admin/AdminCate/cateUpdate', querys)
  },
  // 删除房产分类
  delHouseClassify (querys) {
    return post('/house/admin/AdminCate/cateDel', querys)
  },
  // 获取房源列表
  getHouseList (querys) {
    return post('/house/admin/AdminHouse/houseList', querys)
  },
  // 获取banner列表
  getHouseBannerList (querys) {
    return get('/house/admin/AdminBanner/bannerList', querys)
  },
  // 添加房源banner
  addHouseBanner (querys) {
    return post('/house/admin/AdminBanner/bannerAdd', querys)
  },
  // 编辑、回显、上下架、删除banner
  getEditHouseBanner (querys) {
    return post('/house/admin/AdminBanner/bannerUpdate', querys)
  },
  // 获取房产预约客户列表
  getHouseCustomerList (querys) {
    return get('/house/admin/AdminAppointment/appList', querys)
  },
  // 添加房源信息
  addHouseInfo (querys) {
    return post('/house/admin/AdminHouse/houseAdd', querys)
  },
  // 编辑、回显房源信息
  editGetHouseInfo (querys) {
    return post('/house/admin/AdminHouse/houseUpdate', querys)
  },
  // 获取编辑房源信息的下拉菜单配置项
  getHouseCateList () {
    return get('/house/admin/AdminHouse/houseAbout')
  },
  // 上下架、删除房源信息
  updateHouseInfo (querys) {
    return post('/house/admin/AdminHouse/statusUpdate', querys)
  },
  // 获取房产区域下拉菜单
  getHouseAreaOptions () {
    return get('/house/admin/AdminArea/levelArea')
  },
  // 获取房源区域列表
  getHouseAreaList () {
    return get('/house/admin/AdminArea/areaList')
  },
  // 添加房源区域
  addHouseAreaInfo (querys) {
    return post('/house/admin/AdminArea/areaAdd', querys)
  },
  // 编辑、更新房源区域信息
  updateHouseAreaInfo (querys) {
    return post('/house/admin/AdminArea/areaUpdate', querys)
  },
  // 删除房源区域信息
  delHouseAreaInfo (qeurys) {
    return post('/house/admin/AdminArea/areaDel', qeurys)
  },
  // 获取房源价格列表
  getHousePriceList (querys) {
    return get('/house/admin/AdminPrice/priceList', querys)
  },
  // 添加房源价格信息
  addHousePriceInfo (querys) {
    return post('/house/admin/AdminPrice/priceAdd', querys)
  },
  // 编辑、回显、更新房源价格信息
  updateHousePriceInfo (querys) {
    return post('/house/admin/AdminPrice/priceUpdate', querys)
  },
  // 删除房源价格信息
  delHousePriceInfo (querys) {
    return post('/house/admin/AdminPrice/priceDel', querys)
  },
  // 获取房源户型列表
  getHouseApartmentList (querys) {
    return get('/house/admin/AdminApartment/apartmentList', querys)
  },
  // 添加房源户型信息
  addHouseApartmentInfo (querys) {
    return post('/house/admin/AdminApartment/apartmentAdd', querys)
  },
  // 编辑、回显房源户型信息
  editHosueApartmentInfo (querys) {
    return post('/house/admin/AdminApartment/apartmentUpdate', querys)
  },
  // 删除户型信息
  delHouseApartmentInfo (querys) {
    return post('/house/admin/AdminApartment/apartmentDel', querys)
  },
  // 获取房产样式
  houseSetting (querys) {
    return post('/house/admin/AdminHouse/houseSetting', querys)
  },
  // 设置房产样式
  houseSettingUpdate (querys) {
    return post('/house/admin/AdminHouse/houseSettingUpdate', querys)
  },
  // 获取员工列表
  getHouseStaffInfo (querys) {
    return post('/house/admin/AdminHouse/getStaffInfo', querys)
  }

}



// WEBPACK FOOTER //
// ./src/api/modules/house.js